<template>
  <form class="sp-form" @submit.prevent="beforeSubmit" @keydown.enter="enter">
    <slot />
  </form>
</template>

<script type="text/ecmascript-6">
import { useFormProvide } from '@/hooks/useForm'
import { toRef } from '@vue/runtime-core'
import { isValid, setObjectValue } from '@/utils'
export default {
  name: 'SpForm',

  nameSpace: 'sp-form',

  components: {
  },

  props: {
    checkBeforeSubmit: {
      type: Boolean,
      default: true
    },

    modelValue: {
      type: Object,
      default: null
    },

    defaultValue: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['submit', 'validation'],

  setup (props, { emit }) {
    let { fields, validateForm, setFormItemValue, uploadAllFile } = useFormProvide(toRef(props, 'modelValue'), emit, props.defaultValue)
    const getValue = () => {
      const data = {}
      fields.value.forEach(field => {
        if (field.type !== 'file') {
          setObjectValue(data, field.name, field.model)
        }
      })
      return data
    }
    const setFields = () => {
      fields = useFormProvide(toRef(props, 'modelValue'), emit, props.defaultValue).fields
    }

    const beforeSubmit = () => {
      const params = { fields, data: getValue() }
      if (props.checkBeforeSubmit) {
        validateForm().then(() => {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject()
        }).catch((invalidFields) => {
          if (invalidFields) {
            params.invalidFields = invalidFields
            params.validate = false
            params.uploadAllFile = uploadAllFile
            emit('submit', params)
          } else {
            params.validate = true
            params.uploadAllFile = uploadAllFile
            emit('submit', params)
          }
        })
      } else {
        emit('submit', params)
      }
    }
    const beforeSubmitOnlyValidation = () => {
      const params = { fields, data: getValue() }
      // setFormItemValue({ title: 'Mrs' })
      if (props.checkBeforeSubmit) {
        validateForm().then(() => {
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject()
        }).catch((invalidFields) => {
          if (invalidFields) {
            params.invalidFields = invalidFields
            params.validate = false
            params.uploadAllFile = uploadAllFile
            emit('validation', params)
          } else {
            params.validate = true
            params.uploadAllFile = uploadAllFile
            emit('validation', params)
          }
        })
      } else {
        emit('validation', params)
      }
    }

    const enter = (e) => {
      if (e.target.nodeName === 'INPUT') {
        e.preventDefault()
      }
    }

    const clearForm = () => {
      fields.value.forEach(item => {
        if (!item?.model?.fileList) {
          item.model = null
        }
      })
    }
    return {
      validateForm,
      fields,
      beforeSubmit,
      beforeSubmitOnlyValidation,
      setFormItemValue,
      uploadAllFile,
      enter,
      clearForm,
      setFields
    }
  }

}
</script>

<style scoped lang="less">
.sp-form{
//css、less
}
</style>
